"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserAesDecrypt = browserAesDecrypt;
exports.browserAesEncrypt = browserAesEncrypt;
exports.browserExportKey = browserExportKey;
exports.browserHmacSha256Sign = browserHmacSha256Sign;
exports.browserHmacSha512Sign = browserHmacSha512Sign;
exports.browserImportKey = browserImportKey;
exports.browserSha256 = browserSha256;
exports.browserSha512 = browserSha512;
exports.getAlgo = getAlgo;
exports.getOps = getOps;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var env = _interopRequireWildcard(require("@walletconnect/environment"));

var _constants = require("../constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function getAlgo(type) {
  return type === _constants.AES_BROWSER_ALGO ? {
    length: _constants.AES_LENGTH,
    name: _constants.AES_BROWSER_ALGO
  } : {
    hash: {
      name: _constants.HMAC_BROWSER_ALGO
    },
    name: _constants.HMAC_BROWSER
  };
}

function getOps(type) {
  return type === _constants.AES_BROWSER_ALGO ? [_constants.ENCRYPT_OP, _constants.DECRYPT_OP] : [_constants.SIGN_OP, _constants.VERIFY_OP];
}

function browserExportKey(_x) {
  return _browserExportKey.apply(this, arguments);
}

function _browserExportKey() {
  _browserExportKey = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(cryptoKey) {
    var type,
        subtle,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            type = _args.length > 1 && _args[1] !== undefined ? _args[1] : _constants.AES_BROWSER_ALGO;
            subtle = env.getSubtleCrypto();
            _context.t0 = Uint8Array;
            _context.next = 5;
            return subtle.exportKey("raw", cryptoKey);

          case 5:
            _context.t1 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _browserExportKey.apply(this, arguments);
}

function browserImportKey(_x2) {
  return _browserImportKey.apply(this, arguments);
}

function _browserImportKey() {
  _browserImportKey = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(buffer) {
    var type,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            type = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : _constants.AES_BROWSER_ALGO;
            return _context2.abrupt("return", env.getSubtleCrypto().importKey("raw", buffer, getAlgo(type), true, getOps(type)));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _browserImportKey.apply(this, arguments);
}

function browserAesEncrypt(_x3, _x4, _x5) {
  return _browserAesEncrypt.apply(this, arguments);
}

function _browserAesEncrypt() {
  _browserAesEncrypt = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(iv, key, data) {
    var subtle, cryptoKey, result;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            subtle = env.getSubtleCrypto();
            _context3.next = 3;
            return browserImportKey(key, _constants.AES_BROWSER_ALGO);

          case 3:
            cryptoKey = _context3.sent;
            _context3.next = 6;
            return subtle.encrypt({
              iv: iv,
              name: _constants.AES_BROWSER_ALGO
            }, cryptoKey, data);

          case 6:
            result = _context3.sent;
            return _context3.abrupt("return", new Uint8Array(result));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _browserAesEncrypt.apply(this, arguments);
}

function browserAesDecrypt(_x6, _x7, _x8) {
  return _browserAesDecrypt.apply(this, arguments);
}

function _browserAesDecrypt() {
  _browserAesDecrypt = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4(iv, key, data) {
    var subtle, cryptoKey, result;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            subtle = env.getSubtleCrypto();
            _context4.next = 3;
            return browserImportKey(key, _constants.AES_BROWSER_ALGO);

          case 3:
            cryptoKey = _context4.sent;
            _context4.next = 6;
            return subtle.decrypt({
              iv: iv,
              name: _constants.AES_BROWSER_ALGO
            }, cryptoKey, data);

          case 6:
            result = _context4.sent;
            return _context4.abrupt("return", new Uint8Array(result));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _browserAesDecrypt.apply(this, arguments);
}

function browserHmacSha256Sign(_x9, _x10) {
  return _browserHmacSha256Sign.apply(this, arguments);
}

function _browserHmacSha256Sign() {
  _browserHmacSha256Sign = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee5(key, data) {
    var subtle, cryptoKey, signature;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            subtle = env.getSubtleCrypto();
            _context5.next = 3;
            return browserImportKey(key, _constants.HMAC_BROWSER);

          case 3:
            cryptoKey = _context5.sent;
            _context5.next = 6;
            return subtle.sign({
              length: _constants.HMAC_LENGTH,
              name: _constants.HMAC_BROWSER
            }, cryptoKey, data);

          case 6:
            signature = _context5.sent;
            return _context5.abrupt("return", new Uint8Array(signature));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _browserHmacSha256Sign.apply(this, arguments);
}

function browserHmacSha512Sign(_x11, _x12) {
  return _browserHmacSha512Sign.apply(this, arguments);
}

function _browserHmacSha512Sign() {
  _browserHmacSha512Sign = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee6(key, data) {
    var subtle, cryptoKey, signature;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            subtle = env.getSubtleCrypto();
            _context6.next = 3;
            return browserImportKey(key, _constants.HMAC_BROWSER);

          case 3:
            cryptoKey = _context6.sent;
            _context6.next = 6;
            return subtle.sign({
              length: _constants.LENGTH_512,
              name: _constants.HMAC_BROWSER
            }, cryptoKey, data);

          case 6:
            signature = _context6.sent;
            return _context6.abrupt("return", new Uint8Array(signature));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _browserHmacSha512Sign.apply(this, arguments);
}

function browserSha256(_x13) {
  return _browserSha.apply(this, arguments);
}

function _browserSha() {
  _browserSha = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee7(data) {
    var subtle, result;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            subtle = env.getSubtleCrypto();
            _context7.next = 3;
            return subtle.digest({
              name: _constants.SHA256_BROWSER_ALGO
            }, data);

          case 3:
            result = _context7.sent;
            return _context7.abrupt("return", new Uint8Array(result));

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _browserSha.apply(this, arguments);
}

function browserSha512(_x14) {
  return _browserSha2.apply(this, arguments);
}

function _browserSha2() {
  _browserSha2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee8(data) {
    var subtle, result;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            subtle = env.getSubtleCrypto();
            _context8.next = 3;
            return subtle.digest({
              name: _constants.SHA512_BROWSER_ALGO
            }, data);

          case 3:
            result = _context8.sent;
            return _context8.abrupt("return", new Uint8Array(result));

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _browserSha2.apply(this, arguments);
}